"use client";
import React from "react";
import { Stack, StackProps } from "@mui/material";

export type WcStackProps = StackProps;

export const WcStack = ({ children, ...props }: WcStackProps) => (
  <Stack data-testid="stack" {...props}>
    {children}
  </Stack>
);
export default WcStack;
